<template>
    <div v-for="(item, index) in segments" :key="index" class="journey-section">
        <div class="journey-segment">
            <div class="journey-segment-indicator">
                <div class="indicator" />
                <div class="indicator" />
            </div>
            <div class="journey-segment-details">
                <Location :data="item.departure" />
                <Info
                    :label="item.company?.number"
                    :name="item.company?.name"
                    :ferryName="item.company?.ferryName"
                    :logo="item.company?.logo"
                    :time="item.time"
                    :labels="item.labels"
                    :ticketType="item?.class"
                    :technicalStop="item.technicalStop" />
                <Location :data="item.arrival" />
            </div>
        </div>

        <Stop v-if="!isLast(index)" :time="item.stopTime" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { JourneySegment } from '../Journey.interfaces';
    import Location from '../Shared/Location/Location.vue';
    import Info from '../Shared/Info/Info.vue';
    import Stop from '../Shared/Stop/Stop.vue';

    export default defineComponent({
        name: 'Detailed',
        components: { Location, Info, Stop },
        props: {
            type: String,
            segments: {
                type: Array as PropType<JourneySegment[]>,
                required: true,
            },
        },
        setup(props) {
            const isLast = (index: number) => {
                return props.segments.length - 1 === index;
            };

            return {
                isLast,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward '../Journey.scss';
</style>
